import * as Yup from 'yup';

import { ValidationErrorMessages } from '@constants/forms';

const validationSchema = Yup.object({
  hasAcceptedInformation: Yup.boolean()
    .oneOf([true], ValidationErrorMessages.CONFIRM_POLICY_DOCUMENTS)
    .required(ValidationErrorMessages.FIELD_REQUIRED),
});

export type BHCLegalSectionValues = Yup.InferType<typeof validationSchema>;

export { validationSchema };
